import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { FONT_WEIGHT_MEDIUM, FONT_WEIGHT_REGULAR, brand, gray_1, gray_6 } from '../../../styles/rn/var';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { Dimensions } from 'react-native';
var screenWidth = Dimensions.get('window').width;
var Styles = CustomStyleSheet({
  'csat-card': {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    position: 'relative',
    backgroundColor: '#fff',
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4
  },
  'csat-card-header': {
    height: 48,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  'csat-card-title': _objectSpread({
    height: 48,
    paddingVertical: 16,
    textAlign: 'center',
    fontSize: 16,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  }, FONT_WEIGHT_MEDIUM),
  'csat-card-leave-button': {
    position: 'absolute',
    top: 16,
    right: 12,
    color: 'rgba(0, 0, 0, 0.40)',
    fontSize: 14,
    lineHeight: 16
  },
  'csat-card-talking-bubble-arrow': {
    width: 22,
    marginLeft: screenWidth / 2 - 11,
    marginTop: 20
  },
  'csat-card-talking': {
    marginTop: 0,
    marginRight: 33.5,
    marginBottom: 12,
    marginLeft: 33.5,
    backgroundColor: '#f5f5f5',
    paddingVertical: 6,
    paddingHorizontal: 10,
    overflow: 'hidden',
    borderRadius: 12,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  'csat-card-feedback': {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    paddingVertical: 24,
    paddingHorizontal: 12,
    paddingBottom: 22,
    borderTopWidth: 0.5,
    borderTopColor: gray_6,
    borderStyle: 'solid'
  },
  'csat-card-feedback-option': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  'csat-card-feedback-key': {
    paddingVertical: 0,
    paddingHorizontal: 20,
    marginTop: 18
  },
  'csat-card-feedback-inquiry': {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 26
  },
  'csat-card-feedback-inquiry-text': {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 12
  },
  'csat-card-submit': {
    paddingVertical: 8,
    paddingHorizontal: 2
  },
  'csat-card-submit-button': {
    height: 44,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 6
  },
  'csat-card-submit-text': {
    color: '#fff',
    textAlign: 'center',
    fontSize: 16
  },
  'csat-card-submit-disabled-text': {
    color: 'rgba(0, 0, 0, 0.26)',
    textAlign: 'center',
    fontSize: 16
  },
  'csat-feedback-option-item': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 10,
    marginLeft: 20,
    marginRight: 20
  },
  'csat-feedback-option-item-feedback-icon': {
    marginBottom: 8,
    width: 36,
    height: 36
  },
  'csat-feedback-option-item-active-text': _objectSpread(_objectSpread({
    textAlign: 'center',
    fontSize: 12,
    lineHeight: 14
  }, FONT_WEIGHT_REGULAR), {}, {
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  'csat-feedback-option-item-inactive-text': _objectSpread(_objectSpread({
    textAlign: 'center',
    fontSize: 12,
    lineHeight: 14
  }, FONT_WEIGHT_REGULAR), {}, {
    color: 'rgba(0, 0, 0, 0.40)'
  }),
  'csat-feedback-key-item': {
    display: 'flex',
    // grid web-chatbot-rn 版本目前好像不支持
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  'csat-feedback-key-item-row': {
    display: 'flex',
    // grid web-chatbot-rn 版本目前好像不支持
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  'csat-feedback-key-item-active': _objectSpread(_objectSpread({
    padding: 8,
    height: 28,
    margin: 6,
    overflow: 'hidden',
    borderRadius: 4,
    fontSize: 12,
    lineHeight: 12,
    textAlign: 'center',
    color: brand
  }, FONT_WEIGHT_REGULAR), {}, {
    borderWidth: 1,
    borderColor: brand,
    borderStyle: 'solid'
  }),
  'csat-feedback-key-item-inactive': _objectSpread(_objectSpread({
    padding: 8,
    height: 28,
    margin: 6,
    overflow: 'hidden',
    borderRadius: 4,
    fontSize: 12,
    lineHeight: 12,
    textAlign: 'center',
    color: gray_1
  }, FONT_WEIGHT_REGULAR), {}, {
    borderWidth: 1,
    borderColor: gray_6,
    borderStyle: 'solid'
  }),
  'inquiry-item-container': {
    display: 'flex',
    // grid web-chatbot-rn 版本目前好像不支持
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  'inquiry-item-row': {
    display: 'flex',
    // grid web-chatbot-rn 版本目前好像不支持
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  'inquiry-item-active-text': _objectSpread(_objectSpread({
    padding: 8,
    height: 32,
    width: 80,
    marginTop: 0,
    marginHorizontal: 4,
    marginBottom: 6,
    overflow: 'hidden',
    borderRadius: 4,
    fontSize: 14,
    lineHeight: 16,
    textAlign: 'center',
    color: brand
  }, FONT_WEIGHT_REGULAR), {}, {
    borderWidth: 1,
    borderColor: brand,
    borderStyle: 'solid'
  }),
  'inquiry-item-inactive-text': _objectSpread(_objectSpread({
    padding: 8,
    height: 32,
    width: 80,
    marginTop: 0,
    marginHorizontal: 4,
    marginBottom: 6,
    overflow: 'hidden',
    borderRadius: 4,
    fontSize: 14,
    lineHeight: 16,
    textAlign: 'center',
    color: gray_1
  }, FONT_WEIGHT_REGULAR), {}, {
    borderWidth: 1,
    borderColor: gray_6,
    borderStyle: 'solid'
  })
});
export default Styles;